// extracted by mini-css-extract-plugin
export default {"directional":"icons_directional__nN84E"};